import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Card, Row, Col, Form, Button, Badge } from 'react-bootstrap';
import Select from 'react-select';

import Header from '~/Components/Header/Header';
import CardNavigationTab from '~/Components/CardNavigationTab';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { getIntermediarias } from '~/Services/Service';

import TabCorrecao from './components/TabCorrecao';
import TabTaxas from './components/TabTaxas';
import TabPrecos from './components/TabPrecos';
import TabTabelas from './components/TabTabelas';
import TabGerarTabela from './components/TabGerarTabela';
import ModalIntermediaria from './components/ModalIntermediaria';

const TabelaPrecos = () => {
  const [activeTab, setActiveTab] = useState('correcao');
  const [familia, setFamilia] = useState(null);
  const [showIntermediaria, setShowIntermediaria] = useState(false);
  const [qtdIntermediarias, setQtdIntermediarias] = useState(0);
  const empreendimentos = useSelector((state) => state.empreendimentos);

  const opcoesEmpreendimento = (empreendimentos.list || []).map((e) => ({
    value: e.codigo,
    label: e.descricao,
  }));

  useEffect(() => {
    if (familia) {
      getIntermediarias(familia.value)
        .then((res) => {
          const ativos = (res || []).filter((i) => i.ativo);
          setQtdIntermediarias(ativos.length);
        })
        .catch(() => setQtdIntermediarias(0));
    } else {
      setQtdIntermediarias(0);
    }
  }, [familia]);

  return (
    <>
      <Header title="Tabela de Preços" />

      <Card className="mb-3">
        <Card.Body>
          <Row>
            <Col md={6}>
              <Form.Label className="small mb-1">Empreendimento</Form.Label>
              <Select
                value={familia}
                onChange={(opt) => {
                  setFamilia(opt);
                  setActiveTab('correcao');
                }}
                options={opcoesEmpreendimento}
                placeholder="Selecione..."
                styles={customStyles}
                components={{ DropdownIndicator }}
                isClearable
              />
            </Col>
            <Col md={3} className="d-flex align-items-end">
              <Button
                variant="outline-primary"
                onClick={() => setShowIntermediaria(true)}
                disabled={!familia}
              >
                Intermediárias{' '}
                {qtdIntermediarias > 0 && (
                  <Badge variant="info">{qtdIntermediarias}</Badge>
                )}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {familia && (
        <CardNavigationTab
          activeTab={activeTab}
          onChangeTab={setActiveTab}
          tabs={[
            {
              label: 'Correção',
              url: 'correcao',
              component: <TabCorrecao familia={familia.value} />,
            },
            {
              label: 'Taxas',
              url: 'taxas',
              component: <TabTaxas />,
            },
            {
              label: 'Preços',
              url: 'precos',
              component: <TabPrecos familia={familia.value} />,
            },
            {
              label: 'Tabelas de Preço',
              url: 'tabelas',
              component: <TabTabelas familia={familia.value} />,
            },
            {
              label: 'Gerar Tabela',
              url: 'gerar',
              component: (
                <TabGerarTabela
                  familia={familia.value}
                  onGerado={() => setActiveTab('tabelas')}
                />
              ),
            },
          ]}
        />
      )}

      <ModalIntermediaria
        show={showIntermediaria}
        onHide={() => setShowIntermediaria(false)}
        familia={familia && familia.value}
        onCountChange={setQtdIntermediarias}
      />
    </>
  );
};

export default TabelaPrecos;
